import type { Bundle } from '../types'

/** Connexion, menu latéral, barre du haut, états d'erreur partagés. */
export const shell = {
  // Connexion
  'login.product': { fr: 'Compliance Crawler', en: 'Compliance Crawler' },
  'login.submit': { fr: 'Se connecter', en: 'Sign in' },
  'login.submitting': { fr: 'Connexion…', en: 'Signing in…' },
  'login.badCredentials': { fr: 'Identifiants invalides', en: 'Invalid credentials' },
  'login.failed': { fr: 'Erreur de connexion', en: 'Sign-in failed' },

  // Menu latéral
  'shell.nav': { fr: 'Navigation principale', en: 'Main navigation' },
  'shell.openMenu': { fr: 'Ouvrir le menu', en: 'Open menu' },
  'shell.expandMenu': { fr: 'Déplier le menu', en: 'Expand menu' },
  'shell.collapseMenu': { fr: 'Rabattre le menu', en: 'Collapse menu' },
  'shell.breadcrumb': { fr: "Fil d'Ariane", en: 'Breadcrumb' },
  'shell.logout': { fr: 'Se déconnecter', en: 'Sign out' },
  'shell.allOrgs': { fr: 'Toutes les organisations', en: 'All organisations' },
  'shell.viewOrgData': { fr: "Voir les données d'une organisation", en: 'View one organisation’s data' },
  'shell.reportTitle': { fr: 'Bilan mensuel de surveillance au format PDF', en: 'Monthly monitoring summary as PDF' },
  'shell.report': { fr: 'Rapport', en: 'Report' },
  'shell.reportFailed': { fr: "Le rapport n'a pas pu être généré : {error}", en: 'The report could not be generated: {error}' },

  // États d'erreur
  'error.title': { fr: 'Données indisponibles', en: 'Data unavailable' },
  'error.noAnswer': { fr: "Le serveur n'a pas répondu.", en: 'The server did not respond.' },
  'error.inZone': { fr: 'Erreur dans « {label} »', en: 'Error in “{label}”' },
  'error.generic': { fr: 'Une erreur est survenue', en: 'Something went wrong' },
  'error.unknown': { fr: 'Erreur inconnue.', en: 'Unknown error.' },
  'error.unreachable': {
    fr: 'Serveur injoignable. Vérifiez que le service est démarré, puis réessayez.',
    en: 'Server unreachable. Check that the service is running, then retry.',
  },
  'error.sessionExpired': { fr: 'Session expirée. Reconnectez-vous.', en: 'Session expired. Please sign in again.' },
  'error.forbidden': {
    fr: "Vous n'avez pas les droits nécessaires pour cette donnée.",
    en: 'You do not have the rights required for this data.',
  },
  'error.notFound': { fr: 'Ressource introuvable.', en: 'Resource not found.' },
  'error.tooManyRequests': {
    fr: 'Trop de requêtes. Patientez quelques instants avant de réessayer.',
    en: 'Too many requests. Wait a moment before retrying.',
  },
  'error.server': {
    fr: 'Erreur du serveur. Si le problème persiste, contactez un administrateur.',
    en: 'Server error. If the problem persists, contact an administrator.',
  },

  // Réponses du serveur traduites côté client
  'api.forbidden': {
    fr: "Vous n'avez pas accès à cette ressource.",
    en: 'You do not have access to this resource.',
  },
  'api.notFound': { fr: 'Ressource introuvable.', en: 'Resource not found.' },
  'api.server': {
    fr: 'Le serveur a rencontré une erreur. Réessayez dans un instant.',
    en: 'The server hit an error. Try again in a moment.',
  },
  'api.status': { fr: 'Erreur {status}', en: 'Error {status}' },
  'api.sessionExpired': {
    fr: 'Session expirée, veuillez vous reconnecter.',
    en: 'Session expired, please sign in again.',
  },

  // File de travaux
  'queue.title': { fr: 'Queue BullMQ', en: 'BullMQ queue' },
  'queue.waiting': { fr: 'En attente', en: 'Waiting' },
  'queue.active': { fr: 'Actifs', en: 'Active' },
  'queue.completed': { fr: 'Terminés', en: 'Completed' },
  'queue.failed': { fr: 'Échoués', en: 'Failed' },
  'queue.delayed': { fr: 'Différés', en: 'Delayed' },
} satisfies Bundle
